import {Backbone} from 'Vertebrae';
import {AffinityGroups as Groups} from 'collection/affinityGroups';

export const GroupService = [
    '$q',
    function($q) {
        return {
            /**
             * NOTE:
             * This is a near exact copy of `control/partner/services/groupService::getGroups`, but that file has too
             * many dependencies so until we merge all the individual angular apps into one, we're going to keep them
             * separate
             * @param category
             */
            getGroups: function(category) {
                var categoryid = null;
                if (category instanceof Backbone.Model) {
                    categoryid = category.get('id');
                } else if (typeof category === 'object') {
                    categoryid = category.id;
                } else {
                    categoryid = category;
                }

                var deferred = $q.defer();

                // then we create a collection of similar experts using this expert
                var groupsCollection = new Groups();

                groupsCollection.fetch({
                    data: {
                        affinityGroupCategoryid: categoryid,
                    },
                }).then(function() {
                    deferred.resolve.call(this, groupsCollection);
                }, function() {
                    deferred.reject.apply(this, arguments);
                });

                return deferred.promise;
            },
        };
    },
];
